module.exports = __webpack_public_path__ + "img/default.96dfbe8e.png";